import axios from 'axios';

const getFundraisersByCampaign = async (campaignId, searchTerm, sortTitle, sortValue, page, pageSize) => {
  try {
    const params = {
      filter_by: 'campaign',
      value: campaignId,
      ...(searchTerm && { search: searchTerm }),
      ...(sortTitle && { sort_title: sortTitle }),
      ...(sortValue && { sort_value: sortValue }),
      page,
      limit: pageSize,
    };
    const response = await axios.get(`${import.meta.env.VITE_API_URL_DASHBOARD_URL}/fundraiser`, { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export default { getFundraisersByCampaign };
